import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import {
  PhotoflipperButton,
  SeeAllReviewsLink,
  ShopAllForSaleLink,
  WriteReview,
} from 'site-modules/shared/components/reviews-links/reviews-links';

import './review-summary-links.scss';

export const REVIEW_LINK = {
  WRITE_REVIEW: 'write_review',
  ALL_REVIEWS: 'all_reviews',
  ALL_FOR_SALE: 'all_for_sale',
  PHOTOFLIPPER: 'photoflipper',
};

export function ReviewSummaryLinks({
  className,
  linksClassName,
  vehicle,
  styleId,
  reviewsCount,
  linksToRender,
  writeReviewTrackingId,
  allForSaleTrackingId,
  target,
}) {
  const {
    make: { name: makeName, slug: makeSlug },
    model: { name: modelName, slug: modelSlug },
    submodels: { name: submodelName, slug: submodelSlug },
    pubStates,
    year,
  } = vehicle;
  const urlParams = { makeSlug, modelSlug, submodelSlug, year, styleId };
  const mmsy = { make: makeName, model: modelName, submodel: submodelName, year };

  const linksProps = { params: urlParams, classes: linksClassName };

  return (
    <div className={classnames('review-summary-links mt-0_75 d-flex flex-column align-items-start', className)}>
      {linksToRender.map(linkToRender => {
        return (
          <Fragment key={linkToRender}>
            {linkToRender === REVIEW_LINK.WRITE_REVIEW && (
              <WriteReview {...linksProps} mmsy={mmsy} data-tracking-id={writeReviewTrackingId} target={target} />
            )}
            {linkToRender === REVIEW_LINK.ALL_REVIEWS && (
              <SeeAllReviewsLink {...linksProps} reviewsCount={reviewsCount} rel="nofollow" target={target} />
            )}
            {linkToRender === REVIEW_LINK.ALL_FOR_SALE && (
              <ShopAllForSaleLink
                {...linksProps}
                mmsy={mmsy}
                pubStates={pubStates}
                trackingId={allForSaleTrackingId}
                target={target}
              />
            )}
            {linkToRender === REVIEW_LINK.PHOTOFLIPPER && <PhotoflipperButton {...linksProps} />}
          </Fragment>
        );
      })}
    </div>
  );
}
ReviewSummaryLinks.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  styleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reviewsCount: PropTypes.number,
  className: PropTypes.string,
  linksClassName: PropTypes.string,
  linksToRender: PropTypes.arrayOf(PropTypes.oneOf(Object.values(REVIEW_LINK))),
  writeReviewTrackingId: PropTypes.string,
  allForSaleTrackingId: PropTypes.string,
  target: PropTypes.string,
};
ReviewSummaryLinks.defaultProps = {
  styleId: null,
  reviewsCount: 0,
  className: null,
  linksClassName: undefined,
  linksToRender: [REVIEW_LINK.WRITE_REVIEW],
  writeReviewTrackingId: 'write_review',
  allForSaleTrackingId: 'view_search_result',
  target: '_self',
};
